<template>
    <div class="annotation-hazard">
        <img
            v-if="ducsHazard"
            :title="$translate('duc_long')"
            class="hazard-icon"
            src="/static/svg/duc_icon.svg"
            alt=""
        />

        <img
            v-if="fragmented"
            :title="$translate('fragmentation')"
            class="hazard-icon"
            src="/static/svg/frag_icon.svg"
            alt=""
        />

        <img
            v-if="pnHazard"
            :title="$uiUtils.formatPnHazardMessage(getPnCount(well))"
            class="hazard-icon"
            src="/static/svg/PN_icon.svg"
            alt=""
        />

        <img
            v-if="degeneratedOocyteHazard"
            :title="$translate('degenerated_oocyte')"
            class="hazard-icon"
            src="/static/svg/degenerated.svg"
            alt=""
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AnnotationHazard',
    props: {
        mkEvent: {
            type: Object,
            default: null
        },
        well: {
            type: Object,
            default: null
        },
        isDuc: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            getPnCount: 'timelapse/getPnCount',
            getPnHazard: 'timelapse/getPnHazard',
            checkDucsHazard: 'timelapse/checkDucsHazard',
            checkDegeneratedOocyteHazard: 'timelapse/checkDegeneratedOocyteHazard'
        }),
        pnHazard() {
            return this.well ? this.getPnHazard(this.well) : false
        },
        ducsHazard() {
            if (this.mkEvent) {
                return this.mkEvent.systemName === 't3' && this.isDuc
            } else {
                return this.checkDucsHazard(this.well)
            }
        },
        fragmented() {
            if (this.mkEvent) {
                return this.mkEvent.fragmented
            } else {
                return !!this.well.inferenceData.morphokinetics.find(mkEvent => mkEvent.fragmented)
            }
        },
        degeneratedOocyteHazard() {
            return this.well && this.checkDegeneratedOocyteHazard(this.well)
        }
    }
}
</script>

<style lang="scss" scoped>
.annotation-hazard {
    display: flex;

    .hazard-icon + .hazard-icon {
        margin-left: 0.25rem;
    }
}
</style>
